module.exports = __webpack_public_path__ + "img/6162638.png";